import type { ReduxState } from '../../../../../../types/reduxTypes';
import type { IconPickerState } from './iconPickerTypes';

export const selectIconPickerState = (state: ReduxState): IconPickerState =>
    state.getIn(['app', 'popup', 'iconPicker']);

export const selectIconSearches = (state: ReduxState) => selectIconPickerState(state).searches;

export const selectRecentIconSearches = (state: ReduxState) => selectIconPickerState(state).recentSearches;
